import { render } from "./PointRuleManager.vue?vue&type=template&id=79f2de70"
import script from "./PointRuleManager.vue?vue&type=script&lang=js"
export * from "./PointRuleManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__